"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionSpinsBuyFeatureController = void 0;
const NolimitPromotionPlugin_1 = require("../../../NolimitPromotionPlugin");
const Logger_1 = require("@nolimit/slot-launcher/bin/utils/Logger");
const PromoPanelButtonIDs_1 = require("../../../enums/PromoPanelButtonIDs");
const PromoPanelEvents_1 = require("../../../events/PromoPanelEvents");
const NolimitApplication_1 = require("@nolimit/slot-launcher/bin/NolimitApplication");
const ActionSpinsBuyFeatureView_1 = require("./ActionSpinsBuyFeatureView");
class ActionSpinsBuyFeatureController {
    get actionSpinsController() {
        return this._actionSpinsController;
    }
    constructor(actionSpinsController, data) {
        this._featureData = [];
        this._actionSpinsController = actionSpinsController;
        this._featureData = data;
        this._betLevels = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getAvailableLevels();
    }
    createView() {
        this._view = new ActionSpinsBuyFeatureView_1.ActionSpinsBuyFeatureView(this);
        this._view.createGameFeatureList(this._featureData);
        this._view.init();
        this.addEventListeners();
    }
    /**
     * button on click method such as buy pop up ok button.
     */
    buttonClick(button, featureData, isManualCall = false) {
        !isManualCall && NolimitPromotionPlugin_1.NolimitPromotionPlugin.sound.playKeypadEffect("click");
        switch (button.name) {
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.BUY:
                if (featureData == undefined) {
                    Logger_1.Logger.warn("featureData is undefined");
                    return;
                }
                this._actionSpinsController.onBuyButtonClicked(featureData, () => this.onBuyBtnPressed(featureData));
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.OK_BTN:
                this.onPopUpOkBtnPressed(featureData);
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.POP_UP_CLOSE:
                this.onPopUpCloseBtnPressed();
                break;
            default:
                Logger_1.Logger.warn("Button click : default case : ", button);
        }
    }
    addEventListeners() {
        NolimitApplication_1.NolimitApplication.events.on(PromoPanelEvents_1.PromoPanelEvents.BALANCE_UPDATE_EVENT, (balance) => this.onBalanceUpdate(balance));
    }
    /**
     * open point for Action spin buy feature
     */
    open() {
        this._view.open();
        this.setBetLevels();
        this._view.closePopUp();
    }
    close(isSelfClose = false) {
        var _a;
        (_a = this._view) === null || _a === void 0 ? void 0 : _a.close(isSelfClose);
    }
    setBetLevels() {
        this._betLevels = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getAvailableLevels();
        if (this._betLevels.length) {
            const currentBetLevel = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
            const currentBetIndex = this._betLevels.indexOf(currentBetLevel);
            currentBetIndex != -1 && this._view.updateFeaturePrice(currentBetLevel);
        }
        else {
            this._betLevels = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getUnavailableLevels();
            const currentBetLevel = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
            const currentBetIndex = this._betLevels.indexOf(currentBetLevel);
            currentBetIndex != -1 && this._view.updateFeaturePrice(currentBetLevel);
        }
    }
    onBalanceUpdate(balance) {
        if (this._view) {
            this.setBetLevels();
            this._view.onBalanceUpdate(balance);
        }
    }
    onBuyBtnPressed(featureData) {
        this._actionSpinsController.view.enableScroll(false);
        this.view.openPopUp(featureData);
    }
    onPopUpOkBtnPressed(featureData) {
        if (featureData != undefined) {
            this._actionSpinsController.startActionSpins(featureData);
            this.close();
            this._actionSpinsController.view.enableScroll(true);
        }
    }
    onPopUpCloseBtnPressed() {
        this._actionSpinsController.view.enableScroll(true);
        this._view.closePopUp();
    }
    get view() {
        return this._view;
    }
    set view(value) {
        this._view = value;
    }
    get promotionPlugin() {
        return this._actionSpinsController.promotionPlugin;
    }
    onGameOptionsUpdate(selectedOptions) {
        this._view.onGameOptionsUpdate(selectedOptions);
    }
}
exports.ActionSpinsBuyFeatureController = ActionSpinsBuyFeatureController;
//# sourceMappingURL=ActionSpinsBuyFeatureController.js.map